// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"218":"acfde830","256":"e0ff82ef","409":"294aa792","499":"f17818b7","599":"f1c8753d","726":"3226df9a","942":"341e14ed"}[chunkId] + ".chunk.js";
};